import { render, staticRenderFns } from "./TutorDirectReport.vue?vue&type=template&id=00984fd9&scoped=true"
import script from "./TutorDirectReport.vue?vue&type=script&lang=js"
export * from "./TutorDirectReport.vue?vue&type=script&lang=js"
import style0 from "./TutorDirectReport.vue?vue&type=style&index=0&id=00984fd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00984fd9",
  null
  
)

export default component.exports